import { render, staticRenderFns } from "./applyReturnOrderrCartManage.vue?vue&type=template&id=1381e2db&scoped=true"
import script from "./applyReturnOrderrCartManage.vue?vue&type=script&lang=js"
export * from "./applyReturnOrderrCartManage.vue?vue&type=script&lang=js"
import style0 from "./applyReturnOrderrCartManage.vue?vue&type=style&index=0&id=1381e2db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1381e2db",
  null
  
)

export default component.exports